import {Event, Settings, Timeline, TipsAndUpdates} from "@mui/icons-material";
import {Box, Stack, StackOwnProps, Typography} from "@mui/material";
import {TypographyVariant} from "@mui/material/styles/createTypography";
import {useThemeContext} from "@theme";

const AppLogo = ({
  logoSize = 60,
  variant = "h4",
  invertColor,
  containerSx,
  hideText,
  animate = false,
  onClick,
}: {
  containerSx?: StackOwnProps;
  logoSize?: number;
  variant?: TypographyVariant;
  invertColor?: boolean;
  hideText?: boolean;
  animate?: boolean;
  onClick?: () => void;
}) => {
  const {theme} = useThemeContext();

  const mainColor = invertColor ? "secondary" : "primary";

  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      gap={2}
      onClick={onClick}
      {...containerSx}>
      <Stack
        flex={1}
        position={"relative"}
        width={logoSize}
        height={logoSize}
        justifyContent={"center"}>
        <Box zIndex={1} alignSelf={"center"}>
          <Timeline
            htmlColor={theme.colors.tertiary}
            sx={{
              fontSize: (logoSize / 100) * 80,
            }}
          />
        </Box>

        <Settings
          color={mainColor}
          sx={{
            fontSize: logoSize,
            position: "absolute",
            animation: animate ? "spin 2s linear infinite" : "none",
            "@keyframes spin": {
              "0%": {
                transform: "rotate(0deg)",
              },
              "100%": {
                transform: "rotate(360deg)",
              },
            },
          }}
        />

        <Stack
          justifyContent={"center"}
          alignItems={"center"}
          borderRadius={"50%"}
          position={"absolute"}
          bottom={"2%"}
          right={"2%"}
          bgcolor={theme.colors.tertiary}
          border={`${logoSize / 30}px solid ${theme.palette.primary.dark}`}
          width={logoSize / 4}
          height={logoSize / 4}>
          <TipsAndUpdates color={mainColor} sx={{width: "80%"}} />
        </Stack>

        <Stack
          justifyContent={"center"}
          alignItems={"center"}
          borderRadius={"50%"}
          position={"absolute"}
          top={"2%"}
          left={"2%"}
          bgcolor={theme.colors.tertiary}
          border={`${logoSize / 30}px solid ${theme.palette.primary.dark}`}
          width={logoSize / 4}
          height={logoSize / 4}>
          <Event color={mainColor} sx={{width: "80%"}} />
        </Stack>
      </Stack>
      {!hideText && (
        <Typography color={mainColor} variant={variant}>
          PREDIMAIN
        </Typography>
      )}
    </Stack>
  );
};

export {AppLogo};
